import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/workplace-xg/workplace-xg/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const ImageGallery = makeShortcode("ImageGallery");
const ImageGalleryImage = makeShortcode("ImageGalleryImage");
const GifPlayer = makeShortcode("GifPlayer");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Unity, not uniformity. “A corporation should be like a painting; everything visible should contribute to the correct total statement.” — Eliot Noyes`}</p>
    </PageDescription>
    <ImageGallery mdxType="ImageGallery">
      <ImageGalleryImage alt="IBM lobby" col={12} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIDBP/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHUlEgKCf/EABoQAQEBAAMBAAAAAAAAAAAAAAECAAMRITH/2gAIAQEAAQUC+Z5A015M0vVyo7//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAfEAABAgYDAAAAAAAAAAAAAAAAARECECEiMVEzcaH/2gAIAQEABj8CZdGy7MuNO3KQen//xAAaEAEAAwEBAQAAAAAAAAAAAAABACFBETFR/9oACAEBAAE/Ic4Dr9ld6wCIGkIsGm8jUKQ7Dg1H/9oADAMBAAIAAwAAABCY/wD/xAAXEQADAQAAAAAAAAAAAAAAAAAAAREh/9oACAEDAQE/EHUaf//EABYRAAMAAAAAAAAAAAAAAAAAAAEQIf/aAAgBAgEBPxAVf//EAB0QAQEAAgEFAAAAAAAAAAAAAAERACExQVGR0fD/2gAIAQEAAT8QFLBYCzTWJRU+bq5DAW2nrAjlbJI0cZC1cCBneTDQGKsb8Z//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM lobby",
            "title": "IBM lobby",
            "src": "/workplace-xg/static/48b1b76cce95d7081cec339586981086/2e753/ibm-lobby.jpg",
            "srcSet": ["/workplace-xg/static/48b1b76cce95d7081cec339586981086/69549/ibm-lobby.jpg 288w", "/workplace-xg/static/48b1b76cce95d7081cec339586981086/473e3/ibm-lobby.jpg 576w", "/workplace-xg/static/48b1b76cce95d7081cec339586981086/2e753/ibm-lobby.jpg 1152w", "/workplace-xg/static/48b1b76cce95d7081cec339586981086/74f4b/ibm-lobby.jpg 1728w", "/workplace-xg/static/48b1b76cce95d7081cec339586981086/f35b7/ibm-lobby.jpg 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM logo brand expression wall signage" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAIDBQT/xAAWAQEBAQAAAAAAAAAAAAAAAAAAAgH/2gAMAwEAAhADEAAAAduNPLU6iCdsDQP/xAAbEAEAAgIDAAAAAAAAAAAAAAACAREAAxATFP/aAAgBAQABBQKWTnYcibjbrSXmVCKHP//EABURAQEAAAAAAAAAAAAAAAAAACAh/9oACAEDAQE/AaP/xAAWEQADAAAAAAAAAAAAAAAAAAABESD/2gAIAQIBAT8BQj//xAAbEAACAgMBAAAAAAAAAAAAAAAAAREhIDEyQf/aAAgBAQAGPwK2kdIlFRo8Enh//8QAHBABAAICAwEAAAAAAAAAAAAAAQARMUEgIWGR/9oACAEBAAE/IWKc9YL9MwASx3CSa2O5aBRnEaqWGuH/2gAMAwEAAgADAAAAEFv/ADz/xAAYEQEAAwEAAAAAAAAAAAAAAAABABARIf/aAAgBAwEBPxBdcIX/AP/EABgRAQADAQAAAAAAAAAAAAAAAAEAECEx/9oACAECAQE/EBTWPb//xAAbEAEAAgMBAQAAAAAAAAAAAAABABEhMUEQgf/aAAgBAQABPxA60F0A1NM+HA6NsHDnAbGNlC627fkKB4yTavIPQMPEuX5//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM logo brand expression wall signage",
            "title": "IBM logo brand expression wall signage",
            "src": "/workplace-xg/static/303e1a8be422c20893ceb69f6462cb52/473e3/ibm-logo-brand-expression-wall-signage.jpg",
            "srcSet": ["/workplace-xg/static/303e1a8be422c20893ceb69f6462cb52/69549/ibm-logo-brand-expression-wall-signage.jpg 288w", "/workplace-xg/static/303e1a8be422c20893ceb69f6462cb52/473e3/ibm-logo-brand-expression-wall-signage.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM bee on back painted wall sign" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAIDAAAAAAAAAAAAAAAAAAIDAQQF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAeHPFqagWyQlIX//xAAaEAACAwEBAAAAAAAAAAAAAAABAgAQEQMy/9oACAEBAAEFAkGxkyuXpjSQ1//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EABQQAQAAAAAAAAAAAAAAAAAAADD/2gAIAQEABj8CH//EABoQAAIDAQEAAAAAAAAAAAAAAAERABAhMXH/2gAIAQEAAT8hARcQarp5MlWCYdf/2gAMAwEAAgADAAAAEEwHwP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/EGM//8QAGhABAAIDAQAAAAAAAAAAAAAAARExABAhkf/aAAgBAQABPxAWE8nKeBruvRhFp4FaSouMRGWdf//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM bee on back painted wall sign",
            "title": "IBM bee on back painted wall sign",
            "src": "/workplace-xg/static/48e48ac03f76407153f18b69729d8bf4/473e3/ibm-bee-on-back-painted-wall-sign.jpg",
            "srcSet": ["/workplace-xg/static/48e48ac03f76407153f18b69729d8bf4/69549/ibm-bee-on-back-painted-wall-sign.jpg 288w", "/workplace-xg/static/48e48ac03f76407153f18b69729d8bf4/473e3/ibm-bee-on-back-painted-wall-sign.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="custom reception desk with mixed materiality" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQADAAAAAAAAAAAAAAAAAAIBAwX/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAB6LVSUkuQAf/EABoQAAEFAQAAAAAAAAAAAAAAAAEAAxARMSD/2gAIAQEAAQUC2TocKu+P/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAGBAAAgMAAAAAAAAAAAAAAAAAABARICH/2gAIAQEABj8Ccm1//8QAGxABAAIDAQEAAAAAAAAAAAAAAQARECExQXH/2gAIAQEAAT8hC1HYidMB1aeXA6p9nsYrH//aAAwDAQACAAMAAAAQHMgA/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFREBAQAAAAAAAAAAAAAAAAAAESD/2gAIAQIBAT8QI//EAB0QAQEBAAICAwAAAAAAAAAAAAERACFREHExgcH/2gAIAQEAAT8QdIoKlLkYh7PAA6JA63NUfSex/HcjCPwyaaOtDf/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "custom reception desk with mixed materiality",
            "title": "custom reception desk with mixed materiality",
            "src": "/workplace-xg/static/7776acb64b18efaeceef31cf9b09d13f/473e3/custom-reception-desk-with-mixed-materiality.jpg",
            "srcSet": ["/workplace-xg/static/7776acb64b18efaeceef31cf9b09d13f/69549/custom-reception-desk-with-mixed-materiality.jpg 288w", "/workplace-xg/static/7776acb64b18efaeceef31cf9b09d13f/473e3/custom-reception-desk-with-mixed-materiality.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="metal mesh and wood reception desk detail" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAQDAv/EABYBAQEBAAAAAAAAAAAAAAAAAAEAAv/aAAwDAQACEAMQAAABuxB5WMslwm4n/8QAGxAAAgIDAQAAAAAAAAAAAAAAAAECAxESMSH/2gAIAQEAAQUCG/cD5VByloS5Q81n/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAGRAAAQUAAAAAAAAAAAAAAAAAEQABECBB/9oACAEBAAY/AkGk5X//xAAaEAACAwEBAAAAAAAAAAAAAAAAARARMSFR/9oACAEBAAE/IdEOAenLAVB9G5pe1H//2gAMAwEAAgADAAAAEMPggP/EABURAQEAAAAAAAAAAAAAAAAAABBB/9oACAEDAQE/ECH/xAAXEQADAQAAAAAAAAAAAAAAAAABECEx/9oACAECAQE/EDEdX//EABsQAQEBAQADAQAAAAAAAAAAAAERADEhkbFR/9oACAEBAAE/ECG+9OFuVd1U1jg8g9d+L3vg+5gSUVB3IXm//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "metal mesh and wood reception desk detail",
            "title": "metal mesh and wood reception desk detail",
            "src": "/workplace-xg/static/885bacbbb851c4015601cf4851474013/473e3/metal-mesh-and-wood-reception-desk-detail.jpg",
            "srcSet": ["/workplace-xg/static/885bacbbb851c4015601cf4851474013/69549/metal-mesh-and-wood-reception-desk-detail.jpg 288w", "/workplace-xg/static/885bacbbb851c4015601cf4851474013/473e3/metal-mesh-and-wood-reception-desk-detail.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="metal mesh and wood reception desk" col={8} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAEEAv/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAG3bmigRX//xAAaEAACAwEBAAAAAAAAAAAAAAABAgARMRAS/9oACAEBAAEFAmajvCLnlki5/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGBAAAgMAAAAAAAAAAAAAAAAAACEBECL/2gAIAQEABj8CFeZQz//EABkQAQEBAQEBAAAAAAAAAAAAAAERACFBEP/aAAgBAQABPyGFTj7iCqnwBHKl7PNUx3f/2gAMAwEAAgADAAAAEB8P/8QAFhEAAwAAAAAAAAAAAAAAAAAAARAR/9oACAEDAQE/EBF//8QAFxEAAwEAAAAAAAAAAAAAAAAAARARQf/aAAgBAgEBPxA3F//EABwQAAICAgMAAAAAAAAAAAAAAAERACExUUFxkf/aAAgBAQABPxBdJqZENfbhx3LheEEGG1pRox7G1iXbn//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "metal mesh and wood reception desk",
            "title": "metal mesh and wood reception desk",
            "src": "/workplace-xg/static/3a1d21a4a4111ece7847aa1c2ec2b4e4/2e753/metal-mesh-and-wood-reception-desk.jpg",
            "srcSet": ["/workplace-xg/static/3a1d21a4a4111ece7847aa1c2ec2b4e4/69549/metal-mesh-and-wood-reception-desk.jpg 288w", "/workplace-xg/static/3a1d21a4a4111ece7847aa1c2ec2b4e4/473e3/metal-mesh-and-wood-reception-desk.jpg 576w", "/workplace-xg/static/3a1d21a4a4111ece7847aa1c2ec2b4e4/2e753/metal-mesh-and-wood-reception-desk.jpg 1152w", "/workplace-xg/static/3a1d21a4a4111ece7847aa1c2ec2b4e4/a052a/metal-mesh-and-wood-reception-desk.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM Watson IoT Munich" col={8} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.66666666666666%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIDAQT/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABdq4ROkl//8QAGhABAQACAwAAAAAAAAAAAAAAAQACEgMRE//aAAgBAQABBQLQbzjEDXNteWOy/8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQMBAT8BV//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAECAQE/AUf/xAAfEAABAQkBAAAAAAAAAAAAAAAAQQEDERIhIjEzgaL/2gAIAQEABj8CUUwUeQ4bvJc2Y//EAB0QAQACAgIDAAAAAAAAAAAAAAEAEUFRIZFhodH/2gAIAQEAAT8hH2AdFpE5Or9gQ91jhDVeJ5nSUqsbqp//2gAMAwEAAgADAAAAEJMP/8QAFxEBAAMAAAAAAAAAAAAAAAAAAAEhcf/aAAgBAwEBPxCbYf/EABcRAQADAAAAAAAAAAAAAAAAAAABEXH/2gAIAQIBAT8Qimn/xAAgEAEAAQMDBQAAAAAAAAAAAAABEQAhMUFRYYGRobHw/9oACAEBAAE/EJxO3lHOc9ajWBrEmnLmhAFi6xXvUwu+AkNr0/W+qEI7s+BX/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Watson IoT Munich",
            "title": "IBM Watson IoT Munich",
            "src": "/workplace-xg/static/4aa2f559186b37898c10213622d91bf6/2e753/ibm-watson-iot-munich.jpg",
            "srcSet": ["/workplace-xg/static/4aa2f559186b37898c10213622d91bf6/69549/ibm-watson-iot-munich.jpg 288w", "/workplace-xg/static/4aa2f559186b37898c10213622d91bf6/473e3/ibm-watson-iot-munich.jpg 576w", "/workplace-xg/static/4aa2f559186b37898c10213622d91bf6/2e753/ibm-watson-iot-munich.jpg 1152w", "/workplace-xg/static/4aa2f559186b37898c10213622d91bf6/a052a/ibm-watson-iot-munich.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM Irvine" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAQEAAwAAAAAAAAAAAAAAAAQCAQMF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAfVzxMVOom5RaQf/xAAcEAABAwUAAAAAAAAAAAAAAAABAxARAAIxMjP/2gAIAQEAAQUCo3QJZfky+gx//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAGBAAAgMAAAAAAAAAAAAAAAAAAAEQICH/2gAIAQEABj8CNl0R/8QAHBAAAgICAwAAAAAAAAAAAAAAAREAIRBRYaHB/9oACAEBAAE/IXBOMAc4OWGYGhbrF12fJ1p//9oADAMBAAIAAwAAABATEDz/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EB//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/EB//xAAcEAEAAgIDAQAAAAAAAAAAAAABACERMUFRsWH/2gAIAQEAAT8Qm+VBlVl1F9yoRnJMezmlF91uJqDDmgmU3SfSAU+PJ//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Irvine",
            "title": "IBM Irvine",
            "src": "/workplace-xg/static/fccb3ae50174fbc8c307678f95a1261c/473e3/ibm-irvine.jpg",
            "srcSet": ["/workplace-xg/static/fccb3ae50174fbc8c307678f95a1261c/69549/ibm-irvine.jpg 288w", "/workplace-xg/static/fccb3ae50174fbc8c307678f95a1261c/473e3/ibm-irvine.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Think brand expression" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAECBP/EABYBAQEBAAAAAAAAAAAAAAAAAAABA//aAAwDAQACEAMQAAAB6hjppFBFB//EABUQAQEAAAAAAAAAAAAAAAAAACAR/9oACAEBAAEFAhD/AP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EABQQAQAAAAAAAAAAAAAAAAAAADD/2gAIAQEABj8CH//EABkQAQEBAQEBAAAAAAAAAAAAAAEAETEQIf/aAAgBAQABPyHchh+WbGOQR4cL/9oADAMBAAIAAwAAABC4D37/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EB//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/EB//xAAdEAEAAgICAwAAAAAAAAAAAAABABEhQTFxYaHB/9oACAEBAAE/EE8mG3mAhHUaDqqryPyAcMm+oNYwOjgmsNz0p//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Think brand expression",
            "title": "Think brand expression",
            "src": "/workplace-xg/static/95607a05ff0875f7ecc49d7e7fc48712/473e3/think-brand-expression.jpg",
            "srcSet": ["/workplace-xg/static/95607a05ff0875f7ecc49d7e7fc48712/69549/think-brand-expression.jpg 288w", "/workplace-xg/static/95607a05ff0875f7ecc49d7e7fc48712/473e3/think-brand-expression.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM provoke" col={8} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.66666666666666%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEAv/EABUBAQEAAAAAAAAAAAAAAAAAAAEA/9oADAMBAAIQAxAAAAExWqElYn//xAAaEAACAwEBAAAAAAAAAAAAAAACAwERIgQh/9oACAEBAAEFAg0180CfQlNmXNlQGsf/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAcEAACAgIDAAAAAAAAAAAAAAAAAgEREqEhMmH/2gAIAQEABj8CaCzkacqvw76KV9H/xAAZEAACAwEAAAAAAAAAAAAAAAABEQAhMUH/2gAIAQEAAT8hKmSAyIgB1XXIYezfIQSqpA4himIQam5//9oADAMBAAIAAwAAABAcH//EABcRAQEBAQAAAAAAAAAAAAAAAAEAMVH/2gAIAQMBAT8Qdke3/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQARIf/aAAgBAgEBPxAORl//xAAdEAEAAgMBAAMAAAAAAAAAAAABESEAMUGRYaGx/9oACAEBAAE/EKMBRJg1oxnkpTo2r78yneQ6/cPkQ4RyZ+MRVJHqwg7kMqaxb9z/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM provoke",
            "title": "IBM provoke",
            "src": "/workplace-xg/static/235e313876e9af9d8467538c88f8e8c8/2e753/ibm-provoke.jpg",
            "srcSet": ["/workplace-xg/static/235e313876e9af9d8467538c88f8e8c8/69549/ibm-provoke.jpg 288w", "/workplace-xg/static/235e313876e9af9d8467538c88f8e8c8/473e3/ibm-provoke.jpg 576w", "/workplace-xg/static/235e313876e9af9d8467538c88f8e8c8/2e753/ibm-provoke.jpg 1152w", "/workplace-xg/static/235e313876e9af9d8467538c88f8e8c8/a052a/ibm-provoke.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM Ehingen Germany" col={12} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIDBP/EABYBAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABvfGuIxnD/8QAGhAAAwADAQAAAAAAAAAAAAAAAAECBBITMf/aAAgBAQABBQJZEsuko7s8HTNmf//EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAEDAQE/AYf/xAAVEQEBAAAAAAAAAAAAAAAAAAAAEv/aAAgBAgEBPwG1P//EABkQAAIDAQAAAAAAAAAAAAAAAAABEBIhQf/aAAgBAQAGPwLUyyOGT//EABkQAAIDAQAAAAAAAAAAAAAAAAABESExYf/aAAgBAQABPyHOAz2cOISWSRsmxz6f/9oADAMBAAIAAwAAABCcP//EABYRAQEBAAAAAAAAAAAAAAAAAAARAf/aAAgBAwEBPxCEx//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAECAQE/ELW//8QAGxABAAICAwAAAAAAAAAAAAAAAQARMWEhQVH/2gAIAQEAAT8QaC/8LiqjKBObguB1TFBQMIRtu47QYhLzdE//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Ehingen Germany",
            "title": "IBM Ehingen Germany",
            "src": "/workplace-xg/static/7110109e4ef237e524c33d9276613966/2e753/ibm-ehingen-germany.jpg",
            "srcSet": ["/workplace-xg/static/7110109e4ef237e524c33d9276613966/69549/ibm-ehingen-germany.jpg 288w", "/workplace-xg/static/7110109e4ef237e524c33d9276613966/473e3/ibm-ehingen-germany.jpg 576w", "/workplace-xg/static/7110109e4ef237e524c33d9276613966/2e753/ibm-ehingen-germany.jpg 1152w", "/workplace-xg/static/7110109e4ef237e524c33d9276613966/74f4b/ibm-ehingen-germany.jpg 1728w", "/workplace-xg/static/7110109e4ef237e524c33d9276613966/f35b7/ibm-ehingen-germany.jpg 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="punch card" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "578px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "99.65277777777779%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAIDAf/EABYBAQEBAAAAAAAAAAAAAAAAAAEAA//aAAwDAQACEAMQAAABjuVa5aINl0GhH//EABgQAAMBAQAAAAAAAAAAAAAAAAAREgEQ/9oACAEBAAEFAmUPjfGVpWn/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAXEAEAAwAAAAAAAAAAAAAAAAAQICEx/9oACAEBAAY/AjC4/wD/xAAdEAACAQUBAQAAAAAAAAAAAAAAASERQVFxkWHh/9oACAEBAAE/IUrUqmheCu6Mysn0ElhNbho4f//aAAwDAQACAAMAAAAQLAc//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAHxABAAMAAgEFAAAAAAAAAAAAAQARMVGRIUFxgfDx/9oACAEBAAE/ELw9PHnd9sR9Fc3HdTlWGhgs+9wurXxo9sgI3uWBmjBaOHhD8if/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "punch card",
            "title": "punch card",
            "src": "/workplace-xg/static/6a7ea9ed94372ef438d9bd8ed87ee35a/666d6/punch-card.jpg",
            "srcSet": ["/workplace-xg/static/6a7ea9ed94372ef438d9bd8ed87ee35a/69549/punch-card.jpg 288w", "/workplace-xg/static/6a7ea9ed94372ef438d9bd8ed87ee35a/473e3/punch-card.jpg 576w", "/workplace-xg/static/6a7ea9ed94372ef438d9bd8ed87ee35a/666d6/punch-card.jpg 578w"],
            "sizes": "(max-width: 578px) 100vw, 578px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM Aerospace" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAMCBAH/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAG2rchyPBbITB//xAAdEAABBAMBAQAAAAAAAAAAAAABAAIDBBESISIj/9oACAEBAAEFAqrflYHjCgGsViVq3Clyx54eL//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EABsQAQACAgMAAAAAAAAAAAAAAAEAERASMVFx/9oACAEBAAY/Ar7Ye5obcFLNZxP/xAAcEAEAAQUBAQAAAAAAAAAAAAABABEhMUFREJH/2gAIAQEAAT8hIe0EeEL5KOPXM0ZN0x5bAjbiUpQJi8oNPk//2gAMAwEAAgADAAAAEBPIAP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EAB0QAAIDAAIDAAAAAAAAAAAAAAERACExQWGBkaH/2gAIAQEAAT8QGFMN9UJwjizZo3GLeARwWWQ2Fq1ORtOdX2GBPCNCB0A+YSLpuFoGExe2P//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Aerospace",
            "title": "IBM Aerospace",
            "src": "/workplace-xg/static/60034fa12ea3650f178e31bce5003423/473e3/ibm-aerospace.jpg",
            "srcSet": ["/workplace-xg/static/60034fa12ea3650f178e31bce5003423/69549/ibm-aerospace.jpg 288w", "/workplace-xg/static/60034fa12ea3650f178e31bce5003423/473e3/ibm-aerospace.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="wood slat wall detail" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAECBP/EABYBAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAAB7q1i1gaoAf/EABwQAAEEAwEAAAAAAAAAAAAAAAEAAhExECFBQv/aAAgBAQABBQILy3YrBLpF9gFf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAGhAAAgIDAAAAAAAAAAAAAAAAABAB0REhQf/aAAgBAQAGPwIspcNQYf8A/8QAHxAAAwABAwUAAAAAAAAAAAAAAAERITFBcVFhgZHR/9oACAEBAAE/IdzazqWW4+X0bJgJRyxYcTjpuLRVHgJU29xuV32f/9oADAMBAAIAAwAAABA89/8A/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAIBABAAIBBAIDAAAAAAAAAAAAAQARITFBUZGhsXHB8P/aAAgBAQABPxA3UFHRv78ShhU74a8i/EUUu3dZ3K0MNCfk7htYPJREVG0c/RBYGACuZVNd5YQx8bxRkPDPTP/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "wood slat wall detail",
            "title": "wood slat wall detail",
            "src": "/workplace-xg/static/f5babb691384e9a5b500f375d207b20d/473e3/wood-slat-wall-detail.jpg",
            "srcSet": ["/workplace-xg/static/f5babb691384e9a5b500f375d207b20d/69549/wood-slat-wall-detail.jpg 288w", "/workplace-xg/static/f5babb691384e9a5b500f375d207b20d/473e3/wood-slat-wall-detail.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM Yorktown exterior at night" col={8} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIEAwX/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAAB5VUe7KiA/wD/xAAaEAACAwEBAAAAAAAAAAAAAAAAAQIRExID/9oACAEBAAEFAoefRlGmiE+Telsz/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQIBAT8Bp//EABkQAAIDAQAAAAAAAAAAAAAAAAABEBExwf/aAAgBAQAGPwIfTXFUo//EAB0QAAIBBAMAAAAAAAAAAAAAAAABMREhUcFBYXH/2gAIAQEAAT8hqMCTFVctou6hEb+iZkvoxpH/2gAMAwEAAgADAAAAEOvv/8QAFhEAAwAAAAAAAAAAAAAAAAAAAAER/9oACAEDAQE/EEoQ/8QAFhEBAQEAAAAAAAAAAAAAAAAAABEB/9oACAECAQE/ENtX/8QAHBABAAMAAgMAAAAAAAAAAAAAAQARITGBQVFh/9oACAEBAAE/EGqEBy1b0R0DBjvoQith8zLDyN84VlKurKiGDD1c/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Yorktown exterior at night",
            "title": "IBM Yorktown exterior at night",
            "src": "/workplace-xg/static/51b8838184fc2f8e4434aa28744893ff/2e753/ibm-yorktown-exterior-at-night.jpg",
            "srcSet": ["/workplace-xg/static/51b8838184fc2f8e4434aa28744893ff/69549/ibm-yorktown-exterior-at-night.jpg 288w", "/workplace-xg/static/51b8838184fc2f8e4434aa28744893ff/473e3/ibm-yorktown-exterior-at-night.jpg 576w", "/workplace-xg/static/51b8838184fc2f8e4434aa28744893ff/2e753/ibm-yorktown-exterior-at-night.jpg 1152w", "/workplace-xg/static/51b8838184fc2f8e4434aa28744893ff/a052a/ibm-yorktown-exterior-at-night.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM Yorktown interior" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAEDBP/EABUBAQEAAAAAAAAAAAAAAAAAAAEA/9oADAMBAAIQAxAAAAGzXCuRUMgeoJ//xAAbEAACAwEBAQAAAAAAAAAAAAABAgADEhETMv/aAAgBAQABBQLkK8noJW66sYGLVoOcIrlpT8//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAdEAABAwUBAAAAAAAAAAAAAAAAAREhAgMQQXGB/9oACAEBAAY/AicLwhR3LbbpJPT/xAAcEAACAgIDAAAAAAAAAAAAAAAAARExIUFRcYH/2gAIAQEAAT8hKEkNmmjMGtitHyLrMksVTI36IKXpFvY//9oADAMBAAIAAwAAABAgMIP/xAAVEQEBAAAAAAAAAAAAAAAAAAAQAf/aAAgBAwEBPxAh/8QAFhEAAwAAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/EKj/xAAdEAEBAAICAwEAAAAAAAAAAAABEQAxIUFRcYHB/9oACAEBAAE/EHQDnGa8hZ4xa+piEmGHcafmcORdO87dkT7jGSy1Vo38xcAyrBfeAbAzYXP/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Yorktown interior",
            "title": "IBM Yorktown interior",
            "src": "/workplace-xg/static/767da38badc27b10c73b73d7df5d2b5e/473e3/ibm-yorktown-interior.jpg",
            "srcSet": ["/workplace-xg/static/767da38badc27b10c73b73d7df5d2b5e/69549/ibm-yorktown-interior.jpg 288w", "/workplace-xg/static/767da38badc27b10c73b73d7df5d2b5e/473e3/ibm-yorktown-interior.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM Quantum platform on display" col={12} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAQCAwX/xAAWAQEBAQAAAAAAAAAAAAAAAAACAQP/2gAMAwEAAhADEAAAAUatiCig6Zr/xAAaEAACAwEBAAAAAAAAAAAAAAACAwABEhMR/9oACAEBAAEFAjZp2h8WV2viucVylhP/xAAWEQEBAQAAAAAAAAAAAAAAAAAAERL/2gAIAQMBAT8Byj//xAAYEQADAQEAAAAAAAAAAAAAAAAAASECEf/aAAgBAgEBPwFbUh0//8QAGhABAQACAwAAAAAAAAAAAAAAAQARMhIikf/aAAgBAQAGPwJ5OSY7PtqWpal//8QAGhAAAwADAQAAAAAAAAAAAAAAAAERITFBUf/aAAgBAQABPyHpwib8FS21OIuCZiKByTzHAlFNB//aAAwDAQACAAMAAAAQgC//xAAYEQEAAwEAAAAAAAAAAAAAAAABEBEhMf/aAAgBAwEBPxBTe9h//8QAGBEAAwEBAAAAAAAAAAAAAAAAAAERUYH/2gAIAQIBAT8QTWF6Sf/EABkQAQADAQEAAAAAAAAAAAAAAAEAESExQf/aAAgBAQABPxALgWFU8anJklCl9tvyNumCgFvhA8MNdYhYre5HIIVBXJ//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Quantum platform on display",
            "title": "IBM Quantum platform on display",
            "src": "/workplace-xg/static/dcf805add5418b0fe1fff2ef36692d95/2e753/digital-render-of-ibm-q-display.jpg",
            "srcSet": ["/workplace-xg/static/dcf805add5418b0fe1fff2ef36692d95/69549/digital-render-of-ibm-q-display.jpg 288w", "/workplace-xg/static/dcf805add5418b0fe1fff2ef36692d95/473e3/digital-render-of-ibm-q-display.jpg 576w", "/workplace-xg/static/dcf805add5418b0fe1fff2ef36692d95/2e753/digital-render-of-ibm-q-display.jpg 1152w", "/workplace-xg/static/dcf805add5418b0fe1fff2ef36692d95/74f4b/digital-render-of-ibm-q-display.jpg 1728w", "/workplace-xg/static/dcf805add5418b0fe1fff2ef36692d95/f35b7/digital-render-of-ibm-q-display.jpg 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM Quantum platform render in elevator lobby" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "151.04166666666669%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIDBQT/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAB1SNBTiIrdXjBNAr/xAAcEAABBAMBAAAAAAAAAAAAAAACAAEDBBESMxD/2gAIAQEAAQUC81UUm4ZUlnU6vFhwrHcGYWyijAi//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHRAAAgICAwEAAAAAAAAAAAAAAAERMQIQITJxgf/aAAgBAQAGPwK2XkdmTHJQ0saPus/SFqWj/8QAGxAAAwEAAwEAAAAAAAAAAAAAAAERIRAxUfD/2gAIAQEAAT8hSNr6Q6Y6aUyCpqyvcNl+lbnAdF4DoahhwpZ//9oADAMBAAIAAwAAABBD6P7/xAAVEQEBAAAAAAAAAAAAAAAAAAAQEf/aAAgBAwEBPxAp/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQAREP/aAAgBAgEBPxDiC7bf/8QAHxABAAIBAwUAAAAAAAAAAAAAAQARMSFBYVFxkbHB/9oACAEBAAE/EHD0BEr4Q1lPiAyG2sIvDvBFYbmkRNKtkuDpDosvJieg0Vp3uBUHdDRI4I1ZYS5cuLn/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Quantum platform render in elevator lobby",
            "title": "IBM Quantum platform render in elevator lobby",
            "src": "/workplace-xg/static/7098dee36c099b9c1354fbc08496ac76/473e3/ibm-astor-place-quantum-render.jpg",
            "srcSet": ["/workplace-xg/static/7098dee36c099b9c1354fbc08496ac76/69549/ibm-astor-place-quantum-render.jpg 288w", "/workplace-xg/static/7098dee36c099b9c1354fbc08496ac76/473e3/ibm-astor-place-quantum-render.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM Quantum platform plan view" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAECBf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAe/ENAAA/8QAFBABAAAAAAAAAAAAAAAAAAAAMP/aAAgBAQABBQIf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAFBABAAAAAAAAAAAAAAAAAAAAMP/aAAgBAQAGPwIf/8QAGBAAAwEBAAAAAAAAAAAAAAAAAAERECD/2gAIAQEAAT8husguP//aAAwDAQACAAMAAAAQQwg8/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAGhABAQEBAAMAAAAAAAAAAAAAAQARIRBBgf/aAAgBAQABPxBxaw7Dv2M+4ck2A8f/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Quantum platform plan view",
            "title": "IBM Quantum platform plan view",
            "src": "/workplace-xg/static/3d806301867a7285472ef8835cc0f89a/473e3/ibm-q-plan-view.jpg",
            "srcSet": ["/workplace-xg/static/3d806301867a7285472ef8835cc0f89a/69549/ibm-q-plan-view.jpg 288w", "/workplace-xg/static/3d806301867a7285472ef8835cc0f89a/473e3/ibm-q-plan-view.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="brass and solid surface art sample" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQADAAAAAAAAAAAAAAAAAAIBAwX/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAB7Wq5ikCshIP/xAAaEAACAgMAAAAAAAAAAAAAAAAAAREhEBJB/9oACAEBAAEFAuKZGi0bCvP/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAWEQADAAAAAAAAAAAAAAAAAAAAEBH/2gAIAQIBAT8BK//EABkQAAEFAAAAAAAAAAAAAAAAACAAASExUf/aAAgBAQAGPwKA1U4f/8QAHRAAAgIBBQAAAAAAAAAAAAAAAAEQEWEhMUFxgf/aAAgBAQABPyFuwyfYRutHg6hYm5Dj/9oADAMBAAIAAwAAABC3ID7/xAAXEQEAAwAAAAAAAAAAAAAAAAAAARAR/9oACAEDAQE/EGJr/8QAGBEAAgMAAAAAAAAAAAAAAAAAAAEQETH/2gAIAQIBAT8QelBR/8QAHxABAAIBAwUAAAAAAAAAAAAAAQARIRAxUUFhgZHw/9oACAEBAAE/ELZQtYl3B1+eI7xjY88KWxemIb39i4tsMNaFzP/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "brass and solid surface art sample",
            "title": "brass and solid surface art sample",
            "src": "/workplace-xg/static/5c17ab5ff99e10093f38b9e9ad04a9bf/473e3/brass-and-solid-surface-art-sample.jpg",
            "srcSet": ["/workplace-xg/static/5c17ab5ff99e10093f38b9e9ad04a9bf/69549/brass-and-solid-surface-art-sample.jpg 288w", "/workplace-xg/static/5c17ab5ff99e10093f38b9e9ad04a9bf/473e3/brass-and-solid-surface-art-sample.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="large reception area" col={8} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAQCBf/EABYBAQEBAAAAAAAAAAAAAAAAAAACAf/aAAwDAQACEAMQAAABqntxOzOiJNhKIr//xAAaEAACAwEBAAAAAAAAAAAAAAABAgADESIh/9oACAEBAAEFAkHNhYMtTuEbE0GVtxgj+wCf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAER/9oACAECAQE/AaxWv//EABoQAAMBAAMAAAAAAAAAAAAAAAABETEhgZH/2gAIAQEABj8CTIWipnJjRDo1+n//xAAdEAEAAwACAwEAAAAAAAAAAAABABEhQWExUXGB/9oACAEBAAE/IbWFXK0QPkr/AD2wOEqVeXokyGTNiXhkAAekoMH9T//aAAwDAQACAAMAAAAQwxC8/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERMf/aAAgBAwEBPxBaUWkR/8QAFxEBAQEBAAAAAAAAAAAAAAAAABExAf/aAAgBAgEBPxDFcMKf/8QAHhABAAMAAgIDAAAAAAAAAAAAAQARITFRQWFxgZH/2gAIAQEAAT8QfIS+ePUu22jpT7hQwmiy38jVQG1jfNAUpoX4ybm7Qas7jweNKVYYiihSlD1MYx8Hxdz/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "large reception area",
            "title": "large reception area",
            "src": "/workplace-xg/static/1b61e12699a9eeb49bd3cc51400b732a/2e753/large-reception-area.jpg",
            "srcSet": ["/workplace-xg/static/1b61e12699a9eeb49bd3cc51400b732a/69549/large-reception-area.jpg 288w", "/workplace-xg/static/1b61e12699a9eeb49bd3cc51400b732a/473e3/large-reception-area.jpg 576w", "/workplace-xg/static/1b61e12699a9eeb49bd3cc51400b732a/2e753/large-reception-area.jpg 1152w", "/workplace-xg/static/1b61e12699a9eeb49bd3cc51400b732a/a052a/large-reception-area.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM 8-bar logo in blue on blue wall" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAECAwX/xAAYAQACAwAAAAAAAAAAAAAAAAAAAQMEBf/aAAwDAQACEAMQAAAB5ykalbRVIkCYB//EABQQAQAAAAAAAAAAAAAAAAAAADD/2gAIAQEAAQUCH//EABURAQEAAAAAAAAAAAAAAAAAABEg/9oACAEDAQE/ASP/xAAYEQACAwAAAAAAAAAAAAAAAAABEQACEP/aAAgBAgEBPwE3Rj3/xAAUEAEAAAAAAAAAAAAAAAAAAAAw/9oACAEBAAY/Ah//xAAZEAACAwEAAAAAAAAAAAAAAAAAARARIHH/2gAIAQEAAT8hlvpYsf/aAAwDAQACAAMAAAAQ7Dd9/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEQEf/aAAgBAwEBPxBHL//EABcRAQEBAQAAAAAAAAAAAAAAAAEAEBH/2gAIAQIBAT8QbgEBJz//xAAbEAACAgMBAAAAAAAAAAAAAAAAARGBECExQf/aAAgBAQABPxCiihSaldTomuJja9sef//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM 8-bar logo in blue on blue wall",
            "title": "IBM 8-bar logo in blue on blue wall",
            "src": "/workplace-xg/static/b1ea7ee984530dc99f779f4c63d8d703/473e3/ibm-8-bar-logo-in-blue-on-blue-wall.jpg",
            "srcSet": ["/workplace-xg/static/b1ea7ee984530dc99f779f4c63d8d703/69549/ibm-8-bar-logo-in-blue-on-blue-wall.jpg 288w", "/workplace-xg/static/b1ea7ee984530dc99f779f4c63d8d703/473e3/ibm-8-bar-logo-in-blue-on-blue-wall.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="lenticular painted wood slat wall" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMFAv/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAFumOSEUCX/xAAaEAADAQADAAAAAAAAAAAAAAAAAQIDEhMh/9oACAEBAAEFAnaR1pl+U8YoWaRWK5f/xAAVEQEBAAAAAAAAAAAAAAAAAAAQIf/aAAgBAwEBPwGn/8QAFhEBAQEAAAAAAAAAAAAAAAAAEQEQ/9oACAECAQE/AaGf/8QAGBAAAwEBAAAAAAAAAAAAAAAAAAExEEH/2gAIAQEABj8CKNHSvP/EABoQAQEBAAMBAAAAAAAAAAAAAAEAETFBUXH/2gAIAQEAAT8hLD2SquAZ0zuuPjAQ5O83/9oADAMBAAIAAwAAABAP/wD/xAAXEQADAQAAAAAAAAAAAAAAAAABECEx/9oACAEDAQE/EBVxf//EABcRAAMBAAAAAAAAAAAAAAAAABARITH/2gAIAQIBAT8QiWj/xAAaEAEBAQADAQAAAAAAAAAAAAABEQAhMUFR/9oACAEBAAE/EEIK/GCghYBkOUYFwt1CHEZaDU9yLtV63//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "lenticular painted wood slat wall",
            "title": "lenticular painted wood slat wall",
            "src": "/workplace-xg/static/15cfc74ae2a45f472f91a3e85b691cb3/473e3/lenticular-painted-wood-slat-wall.jpg",
            "srcSet": ["/workplace-xg/static/15cfc74ae2a45f472f91a3e85b691cb3/69549/lenticular-painted-wood-slat-wall.jpg 288w", "/workplace-xg/static/15cfc74ae2a45f472f91a3e85b691cb3/473e3/lenticular-painted-wood-slat-wall.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="welcome zone" col={8} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAQBA//EABYBAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABpc8JUrU//8QAGRABAQADAQAAAAAAAAAAAAAAAgEDERIA/9oACAEBAAEFAsaKxvXq5sq8trSt6//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABcRAAMBAAAAAAAAAAAAAAAAAAABEVH/2gAIAQIBAT8BRVh//8QAGhAAAgIDAAAAAAAAAAAAAAAAAREAEAIhMf/aAAgBAQAGPwJkQLFuHQrtf//EABkQAQEBAAMAAAAAAAAAAAAAAAERADFBof/aAAgBAQABPyEtKvM0kJC24hQju28wBMcq7//aAAwDAQACAAMAAAAQGA//xAAYEQADAQEAAAAAAAAAAAAAAAAAASERUf/aAAgBAwEBPxB1Qx9P/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAEhEfD/2gAIAQIBAT8Qh66dmf/EABkQAAMBAQEAAAAAAAAAAAAAAAABESExgf/aAAgBAQABPxBi5Co1SNU4pCU8OTQbSRjxCxim8Q3W2n//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "welcome zone",
            "title": "welcome zone",
            "src": "/workplace-xg/static/ee10c8029bb0a01061626305a05e318e/2e753/welcome-zone.jpg",
            "srcSet": ["/workplace-xg/static/ee10c8029bb0a01061626305a05e318e/69549/welcome-zone.jpg 288w", "/workplace-xg/static/ee10c8029bb0a01061626305a05e318e/473e3/welcome-zone.jpg 576w", "/workplace-xg/static/ee10c8029bb0a01061626305a05e318e/2e753/welcome-zone.jpg 1152w", "/workplace-xg/static/ee10c8029bb0a01061626305a05e318e/a052a/welcome-zone.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM interior signage palette examples" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAUBA//EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAaebNKDkOoAP/8QAGhAAAgIDAAAAAAAAAAAAAAAAAREAAxASE//aAAgBAQABBQIBxLAKl/Tarbnn/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAGRAAAgMBAAAAAAAAAAAAAAAAAREAEiAx/9oACAEBAAY/AsMNQW7j/8QAHBAAAgICAwAAAAAAAAAAAAAAAREAIRAxIEFR/9oACAEBAAE/ISaQlsMENiVgoSXs7HW3w//aAAwDAQACAAMAAAAQUw88/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAHhABAQABAwUAAAAAAAAAAAAAAREAECAhMUFRYZH/2gAIAQEAAT8QUnJ8Y0kJp1zMkcd2QB34xJwX7dvfZ//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM interior signage palette examples",
            "title": "IBM interior signage palette examples",
            "src": "/workplace-xg/static/8745b667dca2378659b8771ccee4977d/473e3/ibm-interior-signage-palette-examples.jpg",
            "srcSet": ["/workplace-xg/static/8745b667dca2378659b8771ccee4977d/69549/ibm-interior-signage-palette-examples.jpg 288w", "/workplace-xg/static/8745b667dca2378659b8771ccee4977d/473e3/ibm-interior-signage-palette-examples.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Gray IBM 8-bar on stone signage" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAECBQME/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAB244eY1FBcEg//8QAGxAAAgMAAwAAAAAAAAAAAAAAAQIAAxEQExT/2gAIAQEAAQUCLqs7FgOy2tmPmbEGJz//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAbEAACAgMBAAAAAAAAAAAAAAAAASExESAyQf/aAAgBAQAGPwKWkdIgjFeloSen/8QAGxABAAICAwAAAAAAAAAAAAAAAQARMUEgYZH/2gAIAQEAAT8hYpztgvrmABVjuE01sRaBDOIlUsNcP//aAAwDAQACAAMAAAAQ8M8A/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAGxABAAIDAQEAAAAAAAAAAAAAAQARITFBgRD/2gAIAQEAAT8QApBYANTRNhwOjsDoKwNjG6Rurt8hQNGSbV441iDADDx5L+//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Gray IBM 8-bar on stone signage",
            "title": "Gray IBM 8-bar on stone signage",
            "src": "/workplace-xg/static/03c2f4f0f357a28912a9f28d89032331/473e3/gray-ibm-8-bar-on-stone-signage.jpg",
            "srcSet": ["/workplace-xg/static/03c2f4f0f357a28912a9f28d89032331/69549/gray-ibm-8-bar-on-stone-signage.jpg 288w", "/workplace-xg/static/03c2f4f0f357a28912a9f28d89032331/473e3/gray-ibm-8-bar-on-stone-signage.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM Corporate Headquarters signage" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAEDBQQG/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAB7M23HPXoFEhaD//EABsQAAICAwEAAAAAAAAAAAAAAAECAAMEEBET/9oACAEBAAEFArrvKHLsJmceQHrSypLIqKuv/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHBAAAQUAAwAAAAAAAAAAAAAAAQACEBEhEiIx/9oACAEBAAY/AhnqyhDEIHIXS6tAj//EAB4QAQABBAIDAAAAAAAAAAAAAAERABAhMUFRcYGh/9oACAEBAAE/ISOzLbFCgGvU2he1JGyzxbwDK+OBb//aAAwDAQACAAMAAAAQkA8A/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAHRABAAICAgMAAAAAAAAAAAAAAQARITFRYUFxgf/aAAgBAQABPxBDQ8GAVXTzBMgMWb5Y7YySrvcvwQgFhaHfE+zBO5Qri4ZXoYgFT//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Corporate Headquarters signage",
            "title": "IBM Corporate Headquarters signage",
            "src": "/workplace-xg/static/bc705a8e1c71ecc995a9b098531ef5f9/473e3/ibm-corporate-headquarters-signage.jpg",
            "srcSet": ["/workplace-xg/static/bc705a8e1c71ecc995a9b098531ef5f9/69549/ibm-corporate-headquarters-signage.jpg 288w", "/workplace-xg/static/bc705a8e1c71ecc995a9b098531ef5f9/473e3/ibm-corporate-headquarters-signage.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM Bangalore arrival zone" col={12} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAMCBAX/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABS1l6MckH/8QAHBAAAgEFAQAAAAAAAAAAAAAAAQIDABESEyEy/9oACAEBAAEFAlYrJtNR+IQMnAsvB//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABoQAAMAAwEAAAAAAAAAAAAAAAABEQIQEoH/2gAIAQEABj8CfhOZWIyeof/EABoQAQEBAAMBAAAAAAAAAAAAAAERACExQVH/2gAIAQEAAT8hieXvrMq78zkFaZUJhwOhQ3//2gAMAwEAAgADAAAAEN//AP/EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABsQAQEAAwADAAAAAAAAAAAAAAERACFRMUFh/9oACAEBAAE/EHHsT1u4jqCJbu81i7Quz3eD3jV4GT5T7hRYIeYVz//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Bangalore arrival zone",
            "title": "IBM Bangalore arrival zone",
            "src": "/workplace-xg/static/e8590a22e249762a1d54824cae056b9b/2e753/ibm-bangalore-arrival-zone.jpg",
            "srcSet": ["/workplace-xg/static/e8590a22e249762a1d54824cae056b9b/69549/ibm-bangalore-arrival-zone.jpg 288w", "/workplace-xg/static/e8590a22e249762a1d54824cae056b9b/473e3/ibm-bangalore-arrival-zone.jpg 576w", "/workplace-xg/static/e8590a22e249762a1d54824cae056b9b/2e753/ibm-bangalore-arrival-zone.jpg 1152w", "/workplace-xg/static/e8590a22e249762a1d54824cae056b9b/74f4b/ibm-bangalore-arrival-zone.jpg 1728w", "/workplace-xg/static/e8590a22e249762a1d54824cae056b9b/f35b7/ibm-bangalore-arrival-zone.jpg 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM Security™ welcome zone brand expression" col={8} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGQAAAQUAAAAAAAAAAAAAAAAAAAECAwQG/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABqSt0ICh//8QAGRABAAMBAQAAAAAAAAAAAAAAAgABAxEx/9oACAEBAAEFAuzLdFBdOdVaANV5P//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABkQAAMAAwAAAAAAAAAAAAAAAAABIRARQf/aAAgBAQAGPwI1zFIkQ//EABoQAQEBAQADAAAAAAAAAAAAAAERACFBYYH/2gAIAQEAAT8hk75zsFXZ70ZwsFMCBfMgmJv/2gAMAwEAAgADAAAAEGvv/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFREBAQAAAAAAAAAAAAAAAAAAARD/2gAIAQIBAT8QZ//EABsQAQADAQADAAAAAAAAAAAAAAEAESFhQVGR/9oACAEBAAE/EFlBBojVQzG4D652GacYffDIXNDxAsAW0Pc//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Security™ welcome zone brand expression",
            "title": "IBM Security™ welcome zone brand expression",
            "src": "/workplace-xg/static/2bdd7d8556df53f2f7fa960d8f9124db/2e753/security-entrance.jpg",
            "srcSet": ["/workplace-xg/static/2bdd7d8556df53f2f7fa960d8f9124db/69549/security-entrance.jpg 288w", "/workplace-xg/static/2bdd7d8556df53f2f7fa960d8f9124db/473e3/security-entrance.jpg 576w", "/workplace-xg/static/2bdd7d8556df53f2f7fa960d8f9124db/2e753/security-entrance.jpg 1152w", "/workplace-xg/static/2bdd7d8556df53f2f7fa960d8f9124db/a052a/security-entrance.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM Security™ wall pattern brand expression" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAEF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAcEVQsolC//EABQQAQAAAAAAAAAAAAAAAAAAADD/2gAIAQEAAQUCH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EABQQAQAAAAAAAAAAAAAAAAAAADD/2gAIAQEABj8CH//EABcQAAMBAAAAAAAAAAAAAAAAAAABEBH/2gAIAQEAAT8hiqMMEj//2gAMAwEAAgADAAAAEPTYwv/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABYRAAMAAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPxAj/8QAGxAAAgMAAwAAAAAAAAAAAAAAABEBECExQfH/2gAIAQEAAT8QHpLK7GXtORAj/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Security™ wall pattern brand expression",
            "title": "IBM Security™ wall pattern brand expression",
            "src": "/workplace-xg/static/5fbe7894dee012bd90ec2e8cbc695843/473e3/security-pattern.jpg",
            "srcSet": ["/workplace-xg/static/5fbe7894dee012bd90ec2e8cbc695843/69549/security-pattern.jpg 288w", "/workplace-xg/static/5fbe7894dee012bd90ec2e8cbc695843/473e3/security-pattern.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="wood floor and felt ceiling in collaborative zone" col={6} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEAf/EABUBAQEAAAAAAAAAAAAAAAAAAAEA/9oADAMBAAIQAxAAAAG7FLGgUF//xAAZEAADAQEBAAAAAAAAAAAAAAABAgMAERL/2gAIAQEAAQUCBDAzwUZ4075sAq13/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAHhAAAgIABwAAAAAAAAAAAAAAABEBAhAhIjFRcaH/2gAIAQEABj8CN/MNMwuJEqmdl0f/xAAbEAEBAAMAAwAAAAAAAAAAAAABEQAhMUFRgf/aAAgBAQABPyFglgx1zAeLeBat+YzY1YZMBh6XI3yORn//2gAMAwEAAgADAAAAEJMv/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFhEBAQEAAAAAAAAAAAAAAAAAAAER/9oACAECAQE/EK2P/8QAGxABAAIDAQEAAAAAAAAAAAAAAQARITFBYYH/2gAIAQEAAT8QRhXi6qBtI2t8gSMTvCMGzvQ9gmwNUi3fYS6TgtA+k//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "wood floor and felt ceiling in collaborative zone",
            "title": "wood floor and felt ceiling in collaborative zone",
            "src": "/workplace-xg/static/4fcf04bb8fcf7f4fd88ac530852b0f2a/968f2/wood-floor-and-felt-ceiling-in-collaborative-zone.jpg",
            "srcSet": ["/workplace-xg/static/4fcf04bb8fcf7f4fd88ac530852b0f2a/69549/wood-floor-and-felt-ceiling-in-collaborative-zone.jpg 288w", "/workplace-xg/static/4fcf04bb8fcf7f4fd88ac530852b0f2a/473e3/wood-floor-and-felt-ceiling-in-collaborative-zone.jpg 576w", "/workplace-xg/static/4fcf04bb8fcf7f4fd88ac530852b0f2a/968f2/wood-floor-and-felt-ceiling-in-collaborative-zone.jpg 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM Cambridge" col={6} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAIEBf/EABYBAQEBAAAAAAAAAAAAAAAAAAECBP/aAAwDAQACEAMQAAABjfngewxmbki+QNGf/8QAGxAAAwADAQEAAAAAAAAAAAAAAQIDABIUISL/2gAIAQEAAQUCoWBh9zyuoZKa06VwyVjzpjeN/8QAGBEAAgMAAAAAAAAAAAAAAAAAAAEQESH/2gAIAQMBAT8B0tT/AP/EABcRAAMBAAAAAAAAAAAAAAAAAAABERD/2gAIAQIBAT8BqJv/xAAfEAACAQIHAAAAAAAAAAAAAAAAEQECIQMQMUFCUpH/2gAIAQEABj8CtVyHOUvDY0qOsGlRc39Jg//EABoQAQEBAQEBAQAAAAAAAAAAAAERACExcfH/2gAIAQEAAT8hnlKjzw3JWuDA4m9rlm4cfjGpg37nNwCwZv/aAAwDAQACAAMAAAAQoy8A/8QAGBEBAQADAAAAAAAAAAAAAAAAABEBMWH/2gAIAQMBAT8QlOys7f/EABgRAAMBAQAAAAAAAAAAAAAAAAABETFR/9oACAECAQE/EGxQrhELD//EACAQAQACAgEEAwAAAAAAAAAAAAEAESFBMVFhccGBkfD/2gAIAQEAAT8Q4roK2Tp38xq5M0pVnuCFVNFEY53l1jiAlFQAodp5hV+j7jx7qGe4oxTwpawAF9mf/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Cambridge",
            "title": "IBM Cambridge",
            "src": "/workplace-xg/static/c5e58d75bbb31cfbc582d47f8e642abd/968f2/ibm-cambridge.jpg",
            "srcSet": ["/workplace-xg/static/c5e58d75bbb31cfbc582d47f8e642abd/69549/ibm-cambridge.jpg 288w", "/workplace-xg/static/c5e58d75bbb31cfbc582d47f8e642abd/473e3/ibm-cambridge.jpg 576w", "/workplace-xg/static/c5e58d75bbb31cfbc582d47f8e642abd/968f2/ibm-cambridge.jpg 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="large connect zone with multiple seating options" col={12} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAQFAgP/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABe54QlrEgT//EABwQAAICAgMAAAAAAAAAAAAAAAECAxEAEgQTMv/aAAgBAQABBQKwMV7LOimHxse3knWT/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGxAAAgIDAQAAAAAAAAAAAAAAAAERITFBUWH/2gAIAQEABj8CfhDpkORGdlcP/8QAHBABAAICAwEAAAAAAAAAAAAAAQARITFBYZGh/9oACAEBAAE/IT7ioF8Wey/CeiHJy7bmvbIH2MI6KM//2gAMAwEAAgADAAAAEETP/8QAFhEBAQEAAAAAAAAAAAAAAAAAACFB/9oACAEDAQE/EMV//8QAGBEAAgMAAAAAAAAAAAAAAAAAAAERIWH/2gAIAQIBAT8QVsnD/8QAGxABAAMBAAMAAAAAAAAAAAAAAQARITFBUXH/2gAIAQEAAT8QozjQ6029CNRSh3HhIHWC7vIKhUbRK/WHWgg7kN0Zge9n/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "large connect zone with multiple seating options",
            "title": "large connect zone with multiple seating options",
            "src": "/workplace-xg/static/50e1693e943880e864b7884a0211e9c7/2e753/large-connect-zone-with-multiple-seating-options.jpg",
            "srcSet": ["/workplace-xg/static/50e1693e943880e864b7884a0211e9c7/69549/large-connect-zone-with-multiple-seating-options.jpg 288w", "/workplace-xg/static/50e1693e943880e864b7884a0211e9c7/473e3/large-connect-zone-with-multiple-seating-options.jpg 576w", "/workplace-xg/static/50e1693e943880e864b7884a0211e9c7/2e753/large-connect-zone-with-multiple-seating-options.jpg 1152w", "/workplace-xg/static/50e1693e943880e864b7884a0211e9c7/74f4b/large-connect-zone-with-multiple-seating-options.jpg 1728w", "/workplace-xg/static/50e1693e943880e864b7884a0211e9c7/f35b7/large-connect-zone-with-multiple-seating-options.jpg 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="lenticular slat wall with be equal color palette" col={8} mdxType="ImageGalleryImage">
        <GifPlayer color='dark' className="video-player" mdxType="GifPlayer">
          <video autoPlay playsInline loop muted src="/workplace-xg/922befafd1ff362fd8a71d5533c496ea/lenticular-slat-wall-with-be-equal-color-palette.mp4" />
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "53.125%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwABAAMAAAAAAAAAAAAAAAAAAAECBf/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHUVJIP/8QAFBABAAAAAAAAAAAAAAAAAAAAIP/aAAgBAQABBQJf/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFBABAAAAAAAAAAAAAAAAAAAAIP/aAAgBAQAGPwJf/8QAGhAAAAcAAAAAAAAAAAAAAAAAAAERICFBUf/aAAgBAQABPyEksRrf/9oADAMBAAIAAwAAABA8P//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAECAQE/EIf/xAAYEAEAAwEAAAAAAAAAAAAAAAABABEgIf/aAAgBAQABPxAI6qBk/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "lenticular slat wall with be equal color palette",
              "title": "lenticular slat wall with be equal color palette",
              "src": "/workplace-xg/static/187e09067b9354a684a01afed7198fc1/2e753/lenticular-slat-wall-with-be-equal-color-palette.jpg",
              "srcSet": ["/workplace-xg/static/187e09067b9354a684a01afed7198fc1/69549/lenticular-slat-wall-with-be-equal-color-palette.jpg 288w", "/workplace-xg/static/187e09067b9354a684a01afed7198fc1/473e3/lenticular-slat-wall-with-be-equal-color-palette.jpg 576w", "/workplace-xg/static/187e09067b9354a684a01afed7198fc1/2e753/lenticular-slat-wall-with-be-equal-color-palette.jpg 1152w", "/workplace-xg/static/187e09067b9354a684a01afed7198fc1/afdee/lenticular-slat-wall-with-be-equal-color-palette.jpg 1357w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </GifPlayer>
      </ImageGalleryImage>
      <ImageGalleryImage alt="bee equal" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAAsSAAALEgHS3X78AAAB90lEQVQ4y2M4uGc32Yhh8Gnet3MHHB3YvYsEzYf27jl28AAEHT2w//C+vVj1Y9EMVAfU42BnF+Tvn52RrqOtvWvrVqz60TXv37Vzz47tJw4f8vX2CvTzS0tOtjQ3BwpCED7NQOkj+/aePnZ0z/Zti+bOtbe1MzEynjpxItDmk0cOA52zf+dONM27IOjA7p3HDx3csGZ1QmyspbnZquVLli9dtGTR/E3r17i7ugT4+S1fvAioAK4eiBgO7jgIRPu37T+x/0RLfbOIsDADA0Ogb/DX97++fvj9+e3Pv9/+F+WWAAV5uLnzs3OP7zt2YPsBiC6G/TO/75/5be+Mr8fn/7cx8GEAg77CHVc3/j+9+teZ1b8vbfi/rO0qFzsvUFxRSnvX1A8HZ/3cN+MbUCPD/sn/gWjvxD/HZ/5vSFkjyCfmahqzd/KfN3f+//rw7+e7/x+f/j254H+kSwUPl0B2SP/RGf/3TfoL0cWwf8o/ODo68/+Wnvf7pvw4POP/pgnPlrZdWNJ2cV3vvUMz/h+c9mdT97sjM/4eQFIP1PwfjvZO/ntoGpD8fXj6/7kVlw1VXDRkLbqydgNt2zvpN1Bq3+S/yOpRNEP0A43cN/k/0BV7J3/fOeHrsVn/94Gk/u1F1YlFM8IUoMemgAwCM7CrwamZGDRENQMAK0RTdASZu50AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "bee equal",
            "title": "bee equal",
            "src": "/workplace-xg/static/539611784e44e8ad5646a7dede4883fb/a5df1/bee-equal.png",
            "srcSet": ["/workplace-xg/static/539611784e44e8ad5646a7dede4883fb/7fc1e/bee-equal.png 288w", "/workplace-xg/static/539611784e44e8ad5646a7dede4883fb/a5df1/bee-equal.png 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="furniture design study" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEAv/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAGlhmGk5X//xAAZEAEAAwEBAAAAAAAAAAAAAAABAAIREBL/2gAIAQEAAQUCpXJ6CFh4wMn/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAWEAADAAAAAAAAAAAAAAAAAAAQIDH/2gAIAQEABj8CFT//xAAcEAADAAEFAAAAAAAAAAAAAAAAAREhMVGBkaH/2gAIAQEAAT8hg18Gxm9MTVC7FMgnJ//aAAwDAQACAAMAAAAQVA//xAAVEQEBAAAAAAAAAAAAAAAAAAAQIf/aAAgBAwEBPxCH/8QAFhEAAwAAAAAAAAAAAAAAAAAAEBEh/9oACAECAQE/EKx//8QAGxABAQEAAgMAAAAAAAAAAAAAAREAMXEhUfD/2gAIAQEAAT8QeynpYEM/XrRDTjhwg8pklXIlWrXbd//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "furniture design study",
            "title": "furniture design study",
            "src": "/workplace-xg/static/a935a73d632c5a08fe7e26c9872e7b85/473e3/furniture-design-study.jpg",
            "srcSet": ["/workplace-xg/static/a935a73d632c5a08fe7e26c9872e7b85/69549/furniture-design-study.jpg 288w", "/workplace-xg/static/a935a73d632c5a08fe7e26c9872e7b85/473e3/furniture-design-study.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="typical IBM connect zone" col={8} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEBf/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAGZsVUuuIE//8QAHRAAAQQCAwAAAAAAAAAAAAAAAgABAwQREhMhMv/aAAgBAQABBQI4w5a4aTZZP29b2MYr/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAHRAAAQQCAwAAAAAAAAAAAAAAAAECESEQMUFRcf/aAAgBAQAGPwJzabHQqTNG8L4Ork//xAAbEAEAAgMBAQAAAAAAAAAAAAABABEhMcFRkf/aAAgBAQABPyHFIaK5MAdFw8ZG2Laz5OotTm2Z/9oADAMBAAIAAwAAABDYH//EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAEDAQE/EKf/xAAWEQEBAQAAAAAAAAAAAAAAAAARAAH/2gAIAQIBAT8QDIv/xAAaEAEAAwEBAQAAAAAAAAAAAAABABEhYTFR/9oACAEBAAE/EMgJqWtGOu6VBYK0B+pFWDhpFDYxcBVXWCkPQTmIURWluqE//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "typical IBM connect zone",
            "title": "typical IBM connect zone",
            "src": "/workplace-xg/static/f0edfed806fcf67375da28a7f62f7883/2e753/typical-ibm-connect-zone.jpg",
            "srcSet": ["/workplace-xg/static/f0edfed806fcf67375da28a7f62f7883/69549/typical-ibm-connect-zone.jpg 288w", "/workplace-xg/static/f0edfed806fcf67375da28a7f62f7883/473e3/typical-ibm-connect-zone.jpg 576w", "/workplace-xg/static/f0edfed806fcf67375da28a7f62f7883/2e753/typical-ibm-connect-zone.jpg 1152w", "/workplace-xg/static/f0edfed806fcf67375da28a7f62f7883/a052a/typical-ibm-connect-zone.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="collaboration zone" col={8} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAQDBf/EABYBAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABr1TZtbjj/8QAGxAAAgIDAQAAAAAAAAAAAAAAAQIAEgMRIRP/2gAIAQEAAQUCGKrF6j0ndOOXYT//xAAVEQEBAAAAAAAAAAAAAAAAAAAAIf/aAAgBAwEBPwFH/8QAFREBAQAAAAAAAAAAAAAAAAAAACH/2gAIAQIBAT8BV//EABoQAQABBQAAAAAAAAAAAAAAAABBARExMlH/2gAIAQEABj8CuxVLZ1L/xAAbEAEAAwEAAwAAAAAAAAAAAAABABExIVFhcf/aAAgBAQABPyHQXB2vkpWQjCroZHRVo8seRTXuf//aAAwDAQACAAMAAAAQGC//xAAWEQADAAAAAAAAAAAAAAAAAAABEBH/2gAIAQMBAT8QgT//xAAWEQADAAAAAAAAAAAAAAAAAAABEBH/2gAIAQIBAT8QpX//xAAcEAEBAQACAwEAAAAAAAAAAAABEQAhYTFRcYH/2gAIAQEAAT8QpH5STCH1ZPB+4YMqXxuTADARb11qAuUifc8NBJDv/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "collaboration zone",
            "title": "collaboration zone",
            "src": "/workplace-xg/static/7e9973af2615a5a173d1a4fcea29ff5b/2e753/collaboration-zone.jpg",
            "srcSet": ["/workplace-xg/static/7e9973af2615a5a173d1a4fcea29ff5b/69549/collaboration-zone.jpg 288w", "/workplace-xg/static/7e9973af2615a5a173d1a4fcea29ff5b/473e3/collaboration-zone.jpg 576w", "/workplace-xg/static/7e9973af2615a5a173d1a4fcea29ff5b/2e753/collaboration-zone.jpg 1152w", "/workplace-xg/static/7e9973af2615a5a173d1a4fcea29ff5b/a052a/collaboration-zone.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="wood pattern wall" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAEE/8QAFgEBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAHdLMWoKAD/xAAUEAEAAAAAAAAAAAAAAAAAAAAw/9oACAEBAAEFAh//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAUEAEAAAAAAAAAAAAAAAAAAAAw/9oACAEBAAY/Ah//xAAbEAACAQUAAAAAAAAAAAAAAAAAEAERMUFhgf/aAAgBAQABPyHBp8KqLL//2gAMAwEAAgADAAAAEFzY/f/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EAB0QAQACAQUBAAAAAAAAAAAAAAEAESExQVFxkWH/2gAIAQEAAT8Q8wciXP2VeRqCAF6Qp5PcRvfkNuo7K6xxP//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "wood pattern wall",
            "title": "wood pattern wall",
            "src": "/workplace-xg/static/11e9a053d97b39b9d78431c2bd856c4d/473e3/wood-pattern-wall.jpg",
            "srcSet": ["/workplace-xg/static/11e9a053d97b39b9d78431c2bd856c4d/69549/wood-pattern-wall.jpg 288w", "/workplace-xg/static/11e9a053d97b39b9d78431c2bd856c4d/473e3/wood-pattern-wall.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="lounge area" col={12} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAwAEBf/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAFg57j2aT//xAAaEAEBAAIDAAAAAAAAAAAAAAABAgARAyEx/9oACAEBAAEFAhiwjZVVLtzh7x9//8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQMBAT8Bp//EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAECAQE/AYf/xAAYEAADAQEAAAAAAAAAAAAAAAAAESEBEP/aAAgBAQAGPwKVDE8Nvf/EABsQAQADAQADAAAAAAAAAAAAAAEAETEhQVGx/9oACAEBAAE/IV3R1zI3z1kpEK8T2GxqbcI1a97P/9oADAMBAAIAAwAAABCTH//EABcRAAMBAAAAAAAAAAAAAAAAAAABEUH/2gAIAQMBAT8Qcol0/8QAFhEBAQEAAAAAAAAAAAAAAAAAABEh/9oACAECAQE/ENrH/8QAGhABAQEBAQEBAAAAAAAAAAAAAREAIZExUf/aAAgBAQABPxBVmf0n7jEdevAHuhWkKhHNoCKRk1nmCTk8zu1XXf/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "lounge area",
            "title": "lounge area",
            "src": "/workplace-xg/static/e3514a9819ee02613667b547da1f496e/2e753/lounge-area.jpg",
            "srcSet": ["/workplace-xg/static/e3514a9819ee02613667b547da1f496e/69549/lounge-area.jpg 288w", "/workplace-xg/static/e3514a9819ee02613667b547da1f496e/473e3/lounge-area.jpg 576w", "/workplace-xg/static/e3514a9819ee02613667b547da1f496e/2e753/lounge-area.jpg 1152w", "/workplace-xg/static/e3514a9819ee02613667b547da1f496e/74f4b/lounge-area.jpg 1728w", "/workplace-xg/static/e3514a9819ee02613667b547da1f496e/f35b7/lounge-area.jpg 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="enclosed meeting room" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMEBf/EABYBAQEBAAAAAAAAAAAAAAAAAAECAP/aAAwDAQACEAMQAAAB02z7J1nPUVsDEUf/xAAbEAABBQEBAAAAAAAAAAAAAAABAAIDERIhIv/aAAgBAQABBQINJTG9FUHy5jsrckaymCjIPX//xAAVEQEBAAAAAAAAAAAAAAAAAAABIP/aAAgBAwEBPwFj/8QAFxEAAwEAAAAAAAAAAAAAAAAAAhEgQf/aAAgBAgEBPwEXsf/EABwQAAEDBQAAAAAAAAAAAAAAAAABEDEREiAhMv/aAAgBAQAGPwJ+UNzQtnD/xAAdEAEBAQEAAQUAAAAAAAAAAAABEQAxECFBUWFx/9oACAEBAAE/IZ0O5BXoY/BjCWC/u6Jr1TKOI90wPvxJN7//2gAMAwEAAgADAAAAEFcovP/EABURAQEAAAAAAAAAAAAAAAAAABAB/9oACAEDAQE/EBT/xAAWEQEBAQAAAAAAAAAAAAAAAAABEBH/2gAIAQIBAT8QS2Cf/8QAGhABAAMBAQEAAAAAAAAAAAAAAQARIUExcf/aAAgBAQABPxCwOixEpgKXgZpUrh2ommrJonNvsbUgyfA55Fhbr0OxL6PjAqFSn2XManJ//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "enclosed meeting room",
            "title": "enclosed meeting room",
            "src": "/workplace-xg/static/b52de295e7617b4c0c580e4a4d3c4dde/473e3/enclosed-meeting-room.jpg",
            "srcSet": ["/workplace-xg/static/b52de295e7617b4c0c580e4a4d3c4dde/69549/enclosed-meeting-room.jpg 288w", "/workplace-xg/static/b52de295e7617b4c0c580e4a4d3c4dde/473e3/enclosed-meeting-room.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="open desk area" col={8} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAUBAgb/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABZwtojsz4f//EABsQAAMAAgMAAAAAAAAAAAAAAAABAgMRBBIi/9oACAEBAAEFAnoi1RpGL0d3Lnk5Ev/EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/ASf/xAAdEAABAgcAAAAAAAAAAAAAAAAAAhEBEBIhMVGx/9oACAEBAAY/Ahock694FUlz/8QAGxAAAgMBAQEAAAAAAAAAAAAAAREAITFBUZH/2gAIAQEAAT8hPh/IyIfYV2OpiXRqEJLs5eSwGX2f/9oADAMBAAIAAwAAABCk/wD/xAAWEQEBAQAAAAAAAAAAAAAAAAABEBH/2gAIAQMBAT8QRMn/xAAXEQEBAQEAAAAAAAAAAAAAAAABABEh/9oACAECAQE/EEO3b//EABwQAQEAAgIDAAAAAAAAAAAAAAERAEEhUTFhwf/aAAgBAQABPxA/1RgomlVFMeEoepiHwVexvvDGSpS211jArJos9Z//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "open desk area",
            "title": "open desk area",
            "src": "/workplace-xg/static/877af2a5190945b90d7f4664ffee279b/2e753/open-desk-area.jpg",
            "srcSet": ["/workplace-xg/static/877af2a5190945b90d7f4664ffee279b/69549/open-desk-area.jpg 288w", "/workplace-xg/static/877af2a5190945b90d7f4664ffee279b/473e3/open-desk-area.jpg 576w", "/workplace-xg/static/877af2a5190945b90d7f4664ffee279b/2e753/open-desk-area.jpg 1152w", "/workplace-xg/static/877af2a5190945b90d7f4664ffee279b/a052a/open-desk-area.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM 8-bar logo gradient wall pattern" col={8} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMFAv/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAFGaSxBSI//xAAbEAEAAgIDAAAAAAAAAAAAAAACAAEDERIhMf/aAAgBAQABBQJjsYtryWKuEafEz//EABcRAAMBAAAAAAAAAAAAAAAAAAABEVH/2gAIAQMBAT8BjI9P/8QAGREAAgMBAAAAAAAAAAAAAAAAABEBAhJR/9oACAECAQE/AdQh14f/xAAXEAADAQAAAAAAAAAAAAAAAAAAEDEB/9oACAEBAAY/Aqrjh//EABoQAQADAQEBAAAAAAAAAAAAAAEAESExQZH/2gAIAQEAAT8hv03YSBmdmgtGpxsYqGadl3n5P//aAAwDAQACAAMAAAAQWx//xAAXEQEAAwAAAAAAAAAAAAAAAAAAASHw/9oACAEDAQE/ELmUP//EABcRAQEBAQAAAAAAAAAAAAAAAAEAMfD/2gAIAQIBAT8QwBdG/8QAHRABAQADAAIDAAAAAAAAAAAAAREAIWFRcYHR8P/aAAgBAQABPxC1G0hoMK5Pb6xCJhWtffcstM3mNWNnlP3fjIirCbDn/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM 8-bar logo gradient wall pattern",
            "title": "IBM 8-bar logo gradient wall pattern",
            "src": "/workplace-xg/static/695200a50f3879b29767dcb8f68d5ce1/2e753/ibm-logo-gradient-wall-art.jpg",
            "srcSet": ["/workplace-xg/static/695200a50f3879b29767dcb8f68d5ce1/69549/ibm-logo-gradient-wall-art.jpg 288w", "/workplace-xg/static/695200a50f3879b29767dcb8f68d5ce1/473e3/ibm-logo-gradient-wall-art.jpg 576w", "/workplace-xg/static/695200a50f3879b29767dcb8f68d5ce1/2e753/ibm-logo-gradient-wall-art.jpg 1152w", "/workplace-xg/static/695200a50f3879b29767dcb8f68d5ce1/a052a/ibm-logo-gradient-wall-art.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM 8-bar logo wall pattern" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAECA//EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAeYMqNQAP//EABcQAQADAAAAAAAAAAAAAAAAAAABIEH/2gAIAQEAAQUCtqX/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAUEAEAAAAAAAAAAAAAAAAAAAAw/9oACAEBAAY/Ah//xAAcEAACAgIDAAAAAAAAAAAAAAAAARExUYFBYfD/2gAIAQEAAT8hd4PSM5qTWhzhFh3HYlH/2gAMAwEAAgADAAAAEDPHAP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EABwQAAICAwEBAAAAAAAAAAAAAAERITEAQWFxUf/aAAgBAQABPxBHgQN+3WFRAscGTzFYlxoGOVhbrZb++4WwLMbISe5VBGnPbxOfkDuB4gNTZwI9ByM//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM 8-bar logo wall pattern",
            "title": "IBM 8-bar logo wall pattern",
            "src": "/workplace-xg/static/2a0fe083c0d74a4054fdb875220e91de/473e3/ibm-pattern-wall.jpg",
            "srcSet": ["/workplace-xg/static/2a0fe083c0d74a4054fdb875220e91de/69549/ibm-pattern-wall.jpg 288w", "/workplace-xg/static/2a0fe083c0d74a4054fdb875220e91de/473e3/ibm-pattern-wall.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM Irvine collaboration zone" col={12} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEAv/EABUBAQEAAAAAAAAAAAAAAAAAAAIB/9oADAMBAAIQAxAAAAFqq5xcFAV//8QAGhAAAgMBAQAAAAAAAAAAAAAAAQIAAxExEv/aAAgBAQABBQJguKtZliqW7PI09//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABURAQEAAAAAAAAAAAAAAAAAABAx/9oACAECAQE/Aaf/xAAYEAACAwAAAAAAAAAAAAAAAAABMRAgI//aAAgBAQAGPwI5Kij/xAAaEAEAAgMBAAAAAAAAAAAAAAABABEhMVEQ/9oACAEBAAE/IV0LpuolrPJeworUHIcjF/K//9oADAMBAAIAAwAAABBcL//EABYRAAMAAAAAAAAAAAAAAAAAAAEQIf/aAAgBAwEBPxARf//EABYRAQEBAAAAAAAAAAAAAAAAAAABEf/aAAgBAgEBPxCmv//EABsQAQADAQADAAAAAAAAAAAAAAEAESExQVFx/9oACAEBAAE/EFILe6j6bsqFMDZvviVhVCkQt0WQ+I6cxjpGZ7Ln/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Irvine collaboration zone",
            "title": "IBM Irvine collaboration zone",
            "src": "/workplace-xg/static/f0694574190b0f9f64e973b2a8d50271/2e753/ibm-irvine-collaboration-zone.jpg",
            "srcSet": ["/workplace-xg/static/f0694574190b0f9f64e973b2a8d50271/69549/ibm-irvine-collaboration-zone.jpg 288w", "/workplace-xg/static/f0694574190b0f9f64e973b2a8d50271/473e3/ibm-irvine-collaboration-zone.jpg 576w", "/workplace-xg/static/f0694574190b0f9f64e973b2a8d50271/2e753/ibm-irvine-collaboration-zone.jpg 1152w", "/workplace-xg/static/f0694574190b0f9f64e973b2a8d50271/74f4b/ibm-irvine-collaboration-zone.jpg 1728w", "/workplace-xg/static/f0694574190b0f9f64e973b2a8d50271/f35b7/ibm-irvine-collaboration-zone.jpg 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM Plex® collage design" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAEC/8QAGAEAAgMAAAAAAAAAAAAAAAAAAAECBAX/2gAMAwEAAhADEAAAAcxNKnpkAMoi/wD/xAAXEAADAQAAAAAAAAAAAAAAAAAAEEEg/9oACAEBAAEFAsUq/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAFBABAAAAAAAAAAAAAAAAAAAAMP/aAAgBAQAGPwIf/8QAGxAAAwACAwAAAAAAAAAAAAAAAAERQWEhMVH/2gAIAQEAAT8hwZpNCd6JoNJD4j1GRM//2gAMAwEAAgADAAAAEFQnAv/EABYRAQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAwEBPxDIj//EABcRAQEBAQAAAAAAAAAAAAAAAAABETH/2gAIAQIBAT8QYq9f/8QAHRABAQACAwADAAAAAAAAAAAAAREAITFBUWFx0f/aAAgBAQABPxATg03iatgCbO8hVdruuGFh30YKrQk54PJjwKjPn9xJBpTfuLQNix3944Jpilc//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Plex® collage design",
            "title": "IBM Plex® collage design",
            "src": "/workplace-xg/static/db72a0f84b65dc35195aba73fc0e3e7b/473e3/ibm-plex-collage-design.jpg",
            "srcSet": ["/workplace-xg/static/db72a0f84b65dc35195aba73fc0e3e7b/69549/ibm-plex-collage-design.jpg 288w", "/workplace-xg/static/db72a0f84b65dc35195aba73fc0e3e7b/473e3/ibm-plex-collage-design.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="IBM Plex® collage pattern wall mural" col={8} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMCBP/EABQBAQAAAAAAAAAAAAAAAAAAAAL/2gAMAwEAAhADEAAAAexPDNEQX//EABsQAAIBBQAAAAAAAAAAAAAAAAECIQADERIx/9oACAEBAAEFAnbA6jqCRcjYlZr/xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAwEBPwEn/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAER/9oACAECAQE/AbWv/8QAHBAAAQMFAAAAAAAAAAAAAAAAAQAQMQISIUFh/9oACAEBAAY/AqRsloRvxxpX/8QAGhABAAMBAQEAAAAAAAAAAAAAAQARIVExof/aAAgBAQABPyFDC/huYlacSBnisl9T00IGCA3F6T//2gAMAwEAAgADAAAAEHDv/8QAFhEBAQEAAAAAAAAAAAAAAAAAAQAR/9oACAEDAQE/EAtl/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERcf/aAAgBAgEBPxBC0g//xAAcEAEBAAMAAwEAAAAAAAAAAAABEQAhMUFhcZH/2gAIAQEAAT8Q1piCUaK/iZwNaux3EVKFaTWaMpKhp78XDCGltJeY15/HP//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Plex® collage pattern wall mural",
            "title": "IBM Plex® collage pattern wall mural",
            "src": "/workplace-xg/static/1db2f53c388ce4da28633c9a962d893b/2e753/ibm-plex-collage-pattern-wall-mural.jpg",
            "srcSet": ["/workplace-xg/static/1db2f53c388ce4da28633c9a962d893b/69549/ibm-plex-collage-pattern-wall-mural.jpg 288w", "/workplace-xg/static/1db2f53c388ce4da28633c9a962d893b/473e3/ibm-plex-collage-pattern-wall-mural.jpg 576w", "/workplace-xg/static/1db2f53c388ce4da28633c9a962d893b/2e753/ibm-plex-collage-pattern-wall-mural.jpg 1152w", "/workplace-xg/static/1db2f53c388ce4da28633c9a962d893b/a052a/ibm-plex-collage-pattern-wall-mural.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="small welcome zone" col={12} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIDAf/EABYBAQEBAAAAAAAAAAAAAAAAAAIAAf/aAAwDAQACEAMQAAAB0ZMolxn/xAAZEAEAAwEBAAAAAAAAAAAAAAABAAIREgP/2gAIAQEAAQUCDKtnk9HBZ0jrP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/ASf/xAAcEAACAgIDAAAAAAAAAAAAAAAAAREhAjEiQXH/2gAIAQEABj8Cxd2OOlNi4yeGzZ//xAAaEAADAQEBAQAAAAAAAAAAAAAAAREhMUFh/9oACAEBAAE/IXPHXijrWQF80v3TiuJhiLE4fYf/2gAMAwEAAgADAAAAEBf/AP/EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAEDAQE/EGf/xAAYEQADAQEAAAAAAAAAAAAAAAAAAREhUf/aAAgBAgEBPxBI9KuH/8QAHRABAQACAQUAAAAAAAAAAAAAAREAIVExQXGBkf/aAAgBAQABPxAIwXSInaObdfSLZ0CGBYwrHxpzU4g4xZcepis0eGZ//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "small welcome zone",
            "title": "small welcome zone",
            "src": "/workplace-xg/static/881446f6ad8ea2898de15f1d6909b81d/2e753/small-welcome-zone.jpg",
            "srcSet": ["/workplace-xg/static/881446f6ad8ea2898de15f1d6909b81d/69549/small-welcome-zone.jpg 288w", "/workplace-xg/static/881446f6ad8ea2898de15f1d6909b81d/473e3/small-welcome-zone.jpg 576w", "/workplace-xg/static/881446f6ad8ea2898de15f1d6909b81d/2e753/small-welcome-zone.jpg 1152w", "/workplace-xg/static/881446f6ad8ea2898de15f1d6909b81d/74f4b/small-welcome-zone.jpg 1728w", "/workplace-xg/static/881446f6ad8ea2898de15f1d6909b81d/f35b7/small-welcome-zone.jpg 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Malmo collaboration zone" col={8} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAQDAv/EABYBAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABpn6wl0RMr5DaUJ//xAAcEAACAgMBAQAAAAAAAAAAAAABAgMRABIiEyH/2gAIAQEAAQUCdF2aMXrWSyce1oz/AEKNZOcIBP8A/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEQEf/aAAgBAwEBPwFGin//xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAgEBPwFjP//EABoQAAEFAQAAAAAAAAAAAAAAABEAARASIUH/2gAIAQEABj8CabDERFeKoyP/xAAdEAACAgMAAwAAAAAAAAAAAAAAAREhMUFREHGR/9oACAEBAAE/IcQV88M8Cf1ldZorEva6ekRuojUjlseGz//aAAwDAQACAAMAAAAQ9OiC/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEREP/aAAgBAwEBPxCoPT//xAAWEQADAAAAAAAAAAAAAAAAAAABICH/2gAIAQIBAT8QCo//xAAbEAEAAwEBAQEAAAAAAAAAAAABABEhMUFhsf/aAAgBAQABPxAwVWrFX3yWoFU0IwVqIaSIUdG3PyKWhVPHtQ3DxolxhBDwlAcA5thttv2f/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Malmo collaboration zone",
            "title": "Malmo collaboration zone",
            "src": "/workplace-xg/static/71811f70efa64913fef4d9974022e3a9/2e753/malmo-se.jpg",
            "srcSet": ["/workplace-xg/static/71811f70efa64913fef4d9974022e3a9/69549/malmo-se.jpg 288w", "/workplace-xg/static/71811f70efa64913fef4d9974022e3a9/473e3/malmo-se.jpg 576w", "/workplace-xg/static/71811f70efa64913fef4d9974022e3a9/2e753/malmo-se.jpg 1152w", "/workplace-xg/static/71811f70efa64913fef4d9974022e3a9/040c5/malmo-se.jpg 1200w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Astor Place rebus distraction pattern" col={4} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "151.04166666666669%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMEAQL/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABjErKBIZlHEKKyX//xAAaEAACAwEBAAAAAAAAAAAAAAABAhAREgAx/9oACAEBAAEFAtdfGNUXejD+kRla/8QAFhEAAwAAAAAAAAAAAAAAAAAAABAR/9oACAEDAQE/AXD/xAAWEQADAAAAAAAAAAAAAAAAAAAAEBL/2gAIAQIBAT8BdH//xAAZEAACAwEAAAAAAAAAAAAAAAAAURAgMUH/2gAIAQEABj8CFPB2w//EAB4QAAICAgIDAAAAAAAAAAAAAAERACEQQTFRYYGR/9oACAEBAAE/ISRs4CFKq3BynCxe0QhCgiPuLz9uA7gChxgTa6cBgI0n/9oADAMBAAIAAwAAABAQBb7/xAAWEQEBAQAAAAAAAAAAAAAAAAARABD/2gAIAQMBAT8QZ3//xAAXEQADAQAAAAAAAAAAAAAAAAAAAREQ/9oACAECAQE/EIRFx//EAB0QAAIDAAMBAQAAAAAAAAAAAAERACExQVFhcbH/2gAIAQEAAT8QIUZuRBbZGzuYB1OSUNtPcoNVWQCOPkTGAIkWa9gxI4uLqs3iGgmk4+eXCSJKsHKGuD3AiJ3DJrYOvkBpQFyduv32CAhgUS7n/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Astor Place rebus distraction pattern",
            "title": "Astor Place rebus distraction pattern",
            "src": "/workplace-xg/static/88997b31c5f655efb3a3d1c2bd1b548f/473e3/astor-place-quantum-render.jpg",
            "srcSet": ["/workplace-xg/static/88997b31c5f655efb3a3d1c2bd1b548f/69549/astor-place-quantum-render.jpg 288w", "/workplace-xg/static/88997b31c5f655efb3a3d1c2bd1b548f/473e3/astor-place-quantum-render.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
    </ImageGallery>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      